import { useState, type FormEvent } from 'react';
import { ApiError } from '../api/envelope';
import { useLogin } from '../api/queries';
import { useTranslate } from '../i18n/useTranslate';
import { ErrorView } from '../ui/ErrorView';

export function LoginPage() {
  const t = useTranslate();
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // 422 alan hataları zarfın `details` alanından gelir; metin SUNUCUDAN ve
  // çözülen dile göre gelir (SEOAI-64) — panelde tekrar yazılmaz.
  const fieldErrors = login.error instanceof ApiError ? login.error.fieldErrors() : {};

  function onSubmit(event: FormEvent): void {
    event.preventDefault();
    login.mutate({ email, password });
  }

  return (
    <main className="centered">
      <form onSubmit={onSubmit} className="card">
        <h1>{t('app.title')}</h1>

        <label>
          {t('auth.email')}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        {fieldErrors.email?.map((message) => <p key={message} className="field-error">{message}</p>)}

        <label>
          {t('auth.password')}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {fieldErrors.password?.map((m) => <p key={m} className="field-error">{m}</p>)}

        <button type="submit" disabled={login.isPending}>
          {login.isPending ? t('auth.signingIn') : t('auth.submit')}
        </button>

        {/* Alan hatası olmayan hatalar (401 gibi) tam görünümde gösterilir. */}
        {login.error && Object.keys(fieldErrors).length === 0 && <ErrorView error={login.error} />}
      </form>
    </main>
  );
}
